import type { InputHTMLAttributes, ReactNode } from 'react';
import { Eye, EyeOff } from 'lucide-react';

// Password text input used by the unauthenticated pages (Login, Reset,
// AcceptInvite). When `onToggleShow` is supplied the Eye/EyeOff button
// renders inside the input; otherwise it's a plain labelled input — used
// for the confirm-password mirrors that share the same `showPassword`
// state but don't carry their own toggle.
type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  id: string;
  label: string;
  labelRight?: ReactNode;
  showPassword: boolean;
  onToggleShow?: () => void;
};

export default function PasswordInput({ id, label, labelRight, showPassword, onToggleShow, className, ...rest }: Props) {
  const inputClass = `navaris-input w-full px-4 py-3 border border-softgrey rounded-xl text-graphite placeholder-coolslate focus:outline-none focus:ring-2 focus:ring-brand focus:border-transparent${onToggleShow ? ' pr-12' : ''}${className ? ` ${className}` : ''}`;
  const input = <input id={id} type={showPassword ? 'text' : 'password'} className={inputClass} {...rest} />;
  return (
    <div>
      {labelRight ? (
        <div className="flex items-center justify-between mb-2">
          <label htmlFor={id} className="block text-sm font-medium text-graphite">{label}</label>
          {labelRight}
        </div>
      ) : (
        <label htmlFor={id} className="block text-sm font-medium text-graphite mb-2">{label}</label>
      )}
      {onToggleShow ? (
        <div className="relative">
          {input}
          <button
            type="button"
            onClick={onToggleShow}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-coolslate hover:text-graphite"
          >
            {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
          </button>
        </div>
      ) : input}
    </div>
  );
}
